import { DefaultQueryParams, isMobile, parseQuery } from '@pascal/pascal-core';
import { brandedGameIds } from '../../enums/brandedPartners';

export const gameResourceNames = {
  background: 'background',
  character: 'character',
  fishPopup: 'fishPopup',
  transition: 'transition',
  marlinFish: 'marlin',
};

export const webGameResources = {
  background: {
    name: gameResourceNames.background,
    path: 'spines/main/background/web/background.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/main/background/web/background.atlas',
      },
    },
  },
  character: {
    name: gameResourceNames.character,
    path: 'spines/main/character/web/character.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/main/character/web/character.atlas',
      },
    },
  },
  fishPopup: {
    name: gameResourceNames.fishPopup,
    path: 'spines/main/fishPopup/web/fishPopup.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/main/fishPopup/web/fishPopup.atlas',
      },
    },
  },
  transition: {
    name: gameResourceNames.transition,
    path: 'spines/main/transition/web/transition.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/main/transition/web/transition.atlas',
      },
    },
  },
};

export const mobileGameResources = {
  background: {
    name: gameResourceNames.background,
    path: 'spines/main/background/mobile/background.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/main/background/mobile/background.atlas',
      },
    },
  },
  character: {
    name: gameResourceNames.character,
    path: 'spines/main/character/mobile/character.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/main/character/mobile/character.atlas',
      },
    },
  },
  fishPopup: {
    name: gameResourceNames.fishPopup,
    path: 'spines/main/fishPopup/mobile/fishPopup.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/main/fishPopup/mobile/fishPopup.atlas',
      },
    },
  },
  transition: {
    name: gameResourceNames.transition,
    path: 'spines/main/transition/mobile/transition.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/main/transition/mobile/transition.atlas',
      },
    },
  },
};

export const BetFairWebGameResources = {
  background: {
    name: gameResourceNames.background,
    path: 'spines/betFair/background/web/background.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/betFair/background/web/background.atlas',
      },
    },
  },
  character: {
    name: gameResourceNames.character,
    path: 'spines/betFair/character/web/character.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/betFair/web/character.atlas',
      },
    },
  },
  fishPopup: {
    name: gameResourceNames.fishPopup,
    path: 'spines/betFair/fishPopup/web/fishPopup.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/betFair/fishPopup/web/fishPopup.atlas',
      },
    },
  },
  transition: {
    name: gameResourceNames.transition,
    path: 'spines/betFair/transition/web/transition.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/betFair/transition/web/transition.atlas',
      },
    },
  },
  marlin: {
    name: gameResourceNames.marlinFish,
    path: 'spines/betFair/transition/web/marlinFish/marlin.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/betFair/transition/web/marlinFish/marlin.atlas',
      },
    },
  },
};

export const BetFairMobileGameResources = {
  background: {
    name: gameResourceNames.background,
    path: 'spines/betFair/background/mobile/background.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/betFair/background/mobile/background.atlas',
      },
    },
  },
  character: {
    name: gameResourceNames.character,
    path: 'spines/betFair/character/mobile/character.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/betFair/character/mobile/character.atlas',
      },
    },
  },
  fishPopup: {
    name: gameResourceNames.fishPopup,
    path: 'spines/betFair/fishPopup/mobile/fishPopup.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/betFair/fishPopup/mobile/fishPopup.atlas',
      },
    },
  },
  transition: {
    name: gameResourceNames.transition,
    path: 'spines/betFair/transition/mobile/transition.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/betFair/transition/mobile/transition.atlas',
      },
    },
  },
  marlin: {
    name: gameResourceNames.marlinFish,
    path: 'spines/betFair/transition/mobile/marlinFish/marlin.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/betFair/transition/mobile/marlinFish/marlin.atlas',
      },
    },
  },
};

export const Web747GameResources = {
  background: {
    name: gameResourceNames.background,
    path: 'spines/747/background/web/background.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/747/background/web/background.atlas',
      },
    },
  },
  character: {
    name: gameResourceNames.character,
    path: 'spines/747/character/web/character.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/747/web/character.atlas',
      },
    },
  },
  fishPopup: {
    name: gameResourceNames.fishPopup,
    path: 'spines/747/fishPopup/web/fishPopup.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/747/fishPopup/web/fishPopup.atlas',
      },
    },
  },
  transition: {
    name: gameResourceNames.transition,
    path: 'spines/747/transition/web/transition.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/747/transition/web/transition.atlas',
      },
    },
  },
  marlin: {
    name: gameResourceNames.marlinFish,
    path: 'spines/747/transition/web/marlinFish/marlin.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/747/transition/web/marlinFish/marlin.atlas',
      },
    },
  },
};

export const Mobile747GameResources = {
  background: {
    name: gameResourceNames.background,
    path: 'spines/747/background/mobile/background.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/747/background/mobile/background.atlas',
      },
    },
  },
  character: {
    name: gameResourceNames.character,
    path: 'spines/747/character/mobile/character.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/747/character/mobile/character.atlas',
      },
    },
  },
  fishPopup: {
    name: gameResourceNames.fishPopup,
    path: 'spines/747/fishPopup/mobile/fishPopup.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/747/fishPopup/mobile/fishPopup.atlas',
      },
    },
  },
  transition: {
    name: gameResourceNames.transition,
    path: 'spines/747/transition/mobile/transition.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/747/transition/mobile/transition.atlas',
      },
    },
  },
  marlin: {
    name: gameResourceNames.marlinFish,
    path: 'spines/747/transition/mobile/marlinFish/marlin.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/747/transition/mobile/marlinFish/marlin.atlas',
      },
    },
  },
};

export const WebTurkishGameResources = {
  background: {
    name: gameResourceNames.background,
    path: 'spines/turkish/background/web/background.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/turkish/background/web/background.atlas',
      },
    },
  },
  character: {
    name: gameResourceNames.character,
    path: 'spines/turkish/character/web/character.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/turkish/web/character.atlas',
      },
    },
  },
  fishPopup: {
    name: gameResourceNames.fishPopup,
    path: 'spines/turkish/fishPopup/web/fishPopup.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/turkish/fishPopup/web/fishPopup.atlas',
      },
    },
  },
  transition: {
    name: gameResourceNames.transition,
    path: 'spines/turkish/transition/web/transition.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/turkish/transition/web/transition.atlas',
      },
    },
  },
  marlin: {
    name: gameResourceNames.marlinFish,
    path: 'spines/turkish/transition/web/marlinFish/marlin.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/turkish/transition/web/marlinFish/marlin.atlas',
      },
    },
  },
};

export const MobileTurkishGameResources = {
  background: {
    name: gameResourceNames.background,
    path: 'spines/turkish/background/mobile/background.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/turkish/background/mobile/background.atlas',
      },
    },
  },
  character: {
    name: gameResourceNames.character,
    path: 'spines/turkish/character/mobile/character.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/turkish/character/mobile/character.atlas',
      },
    },
  },
  fishPopup: {
    name: gameResourceNames.fishPopup,
    path: 'spines/turkish/fishPopup/mobile/fishPopup.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/turkish/fishPopup/mobile/fishPopup.atlas',
      },
    },
  },
  transition: {
    name: gameResourceNames.transition,
    path: 'spines/turkish/transition/mobile/transition.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/turkish/transition/mobile/transition.atlas',
      },
    },
  },
  marlin: {
    name: gameResourceNames.marlinFish,
    path: 'spines/turkish/transition/mobile/marlinFish/marlin.json',
    config: {
      metadata: {
        spineAtlasFile: 'spines/turkish/transition/mobile/marlinFish/marlin.atlas',
      },
    },
  },
};

const brandedGameMobileAnimation = {
  [brandedGameIds.betfair]: BetFairMobileGameResources,
  [brandedGameIds['747']]: Mobile747GameResources,
  [brandedGameIds.turkish]: MobileTurkishGameResources,
};

const brandedGameWebAnimation = {
  [brandedGameIds.betfair]: BetFairWebGameResources,
  [brandedGameIds['747']]: Web747GameResources,
  [brandedGameIds.turkish]: WebTurkishGameResources,
};

const checkedResourcesByGameId = () => {
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
  const gameResources = [];

  if (isMobile()) {
    gameResources.push(brandedGameMobileAnimation[gameId] || mobileGameResources);
  } else {
    gameResources.push(brandedGameWebAnimation[gameId] || webGameResources);
  }

  return gameResources;
};

export const gameResources = checkedResourcesByGameId();
